var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58268 18.334H17.416C17.6591 18.334 17.8923 18.4306 18.0642 18.6025C18.2361 18.7744 18.3327 19.0075 18.3327 19.2507C18.3327 19.4938 18.2361 19.7269 18.0642 19.8988C17.8923 20.0707 17.6591 20.1673 17.416 20.1673H4.58268C4.33957 20.1673 4.10641 20.0707 3.9345 19.8988C3.76259 19.7269 3.66602 19.4938 3.66602 19.2507C3.66602 19.0075 3.76259 18.7744 3.9345 18.6025C4.10641 18.4306 4.33957 18.334 4.58268 18.334ZM3.66602 13.7507L12.8327 4.58398L15.5827 7.33398L6.41602 16.5007H3.66602V13.7507ZM13.7493 3.66732L15.5827 1.83398L18.3327 4.58398L16.4984 6.41823L13.7493 3.66732Z",
    fill: "#51CDA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ad0a0339b6a656440b63ddd9c04d8423.svg";
export { ForwardRef as ReactComponent };